import React, { useState } from 'react';
import './Contact.css';
import { sendPortfolioContactEmail, validateForm } from '../utils/emailService';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  const [validationError, setValidationError] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form data
    const validation = validateForm(formData);
    if (!validation.isValid) {
      setSubmitStatus('error');
      setValidationError(true);
      return;
    }
    
    setIsSubmitting(true);
    setSubmitStatus('');
    setValidationError(false);

    try {
      await sendPortfolioContactEmail(formData);
      setSubmitStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
      setValidationError(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-subtitle">Let's create something beautiful together</p>
        <div className="divider"></div>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Contact Information</h3>
            <div className="info-item">
              <div className="info-icon info-icon-email"></div>
              <div>
                <h4>Email</h4>
                <p>dibamizan.w@gmail.com</p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon info-icon-phone"></div>
              <div>
                <h4>Phone</h4>
                <p>+98 937 300 9962</p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon info-icon-location"></div>
              <div>
                <h4>Location</h4>
                <p>Available for projects in Tehran</p>
              </div>
            </div>
            <div className="social-links">
              <h4>Follow Me</h4>
              <div className="social-icons">
                <a href="https://instagram.com/mynissita" target="_blank" rel="noopener noreferrer" aria-label="Instagram">Instagram</a>
                <a href="#" aria-label="LinkedIn">LinkedIn</a>
                <a href="#" aria-label="Behance">Behance</a>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                placeholder="Your Message"
                rows="6"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <button 
              type="submit" 
              className={`submit-btn ${isSubmitting ? 'submitting' : ''}`}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
            
            {submitStatus === 'success' && (
              <div className="success-message">
                ✅ Thank you for your message! I'll get back to you soon.
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div className="error-message">
                {validationError 
                  ? '❌ Please fill in all required fields correctly.' 
                  : '❌ Sorry, there was an error sending your message. Please try again or contact me directly at dibamizan.w@gmail.com'
                }
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;